const {
    IS_LOADING,
    TEAM_MANAGER_LIST_SUCCESS,
    TEAM_MANAGER_LIST_ERROR,
    TEAM_MANAGER_UPDATE_SUCCESS,
    TEAM_MANAGER_UPDATE_ERROR,
    TEAM_MANAGER_FILTER_SUCCESS,
    TEAM_MANAGER_FILTER_ERROR,
    TEAM_MANAGER_FILTER_LIST_SUCCESS,
    TEAM_MANAGER_FILTER_LIST_ERROR
} = require("../actions/Type");

const initialState = {
    team_manager_list: {},
    team_manager_edit: {},
    loading: false,
    team_manager_filter_list: {}
};

export const TeamManagerReducers = (state = initialState, { type, payload } = {}) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case TEAM_MANAGER_LIST_SUCCESS:
            return {
                ...state,
                team_manager_list: payload,
                loading: false,
            };
        case TEAM_MANAGER_LIST_ERROR:
            return {
                ...state,
                team_manager_list: payload,
                loading: false,
            };

        case TEAM_MANAGER_FILTER_LIST_SUCCESS:
            return {
                ...state,
                team_manager_filter_list: payload,
                loading: false,
            };
        case TEAM_MANAGER_FILTER_LIST_ERROR:
            return {
                ...state,
                team_manager_filter_list: payload,
                loading: false,
            };

        case TEAM_MANAGER_UPDATE_SUCCESS:
            return {
                ...state,
                team_manager_edit: payload,
                loading: false,
            };
        case TEAM_MANAGER_UPDATE_ERROR:
            return {
                ...state,
                team_manager_edit: payload,
                loading: false,
            };

        case TEAM_MANAGER_FILTER_SUCCESS:
            return {
                ...state,
                team_manager_list: payload,
                loading: false,
            };
        case TEAM_MANAGER_FILTER_ERROR:
            return {
                ...state,
                team_manager_list: payload,
                loading: false,
            };
        default:
            return state;
    }
};
